module.exports = __webpack_public_path__ + "img/DichKriegenWirAuchNoch.3d6ed7ad.jpg";